import {makeEntityStore} from '../../../helpers/factory';
import {BaseRootEntityService} from '../../../../api';
// Deep import to avoid models barrel → form/validation → FormUtils → @hit/base cycle.
import FormTemplate from '../../../../models/hit/form/FormTemplate';
import {formTemplateSchema} from '../../../../models/hit/form/schema';

export default makeEntityStore({
  modelCls: FormTemplate,
  service: new BaseRootEntityService('document', FormTemplate),
  schema: formTemplateSchema,
});
